import React from "react";

import { Box } from "@mui/material";

type TripTabLabelProps = {
  label: string;
};

function TripTabLabel(props: TripTabLabelProps) {
  const { label } = props;

  return (
    <Box
      component="span"
      sx={{
        display: "block",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  );
}

export default TripTabLabel;
